import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { OUTLINE_COLOR_LIGHT } from '@CSSVars/colors'

export const _InfoDivider = styled.span`
  padding: 0 8px;
  color: ${OUTLINE_COLOR_LIGHT};
  font-size: 11px;
`
